<template>
  <div class="imgListWrap clearfix">
    <div class="uploadWrap" v-if="edit">
      <form class="js-formClear">
        <input v-show="!isMultiple" type="file" class="inputFile" @change="fileChange" ref="inputFile" accept="image/*" />
        <input v-show="isMultiple" type="file" class="inputFile" @change="fileChange" ref="inputFile" accept="image/*" multiple="isMultiple"/>
      </form>
    </div>
    <div :class="loading?'imgLoading active':'imgLoading'">
      加载中...
    </div>
    <viewer :images="imgShowList" v-if="!edit">
      <div v-for="image in imgShowList" :key="image.url" class="imgPreviewBox">
        <img :src="image.url" class="imgStyle">
        <span>{{image.desc}}</span>
      </div>
    </viewer>
    <ImgPreview :imgList="imgShowList" @delImg="delImg($event)" :edit="edit" v-else/>
  </div>
</template>
<script>
import ImgPreview from './img-preview.vue';

export default {
  data () {
    return {
      imgList: [], // 记录所有的图片：显示（老的、新添加的）、不显示
      loading: false
    };
  },
  computed: {
    imgShowList: function () { // 只记录显示的图片
      return this.imgList.filter(item => item.status != 0);
    }
  },
  props: {
    images: { // 图片list 用于图片回显初始化
      type: Array,
      default: function () {
        return []; // 格式：[{ url: '' }, { url: '' }]
      }
    },
    uploadUrl: { // 上传图片时是否带着key值  默认为false
      type: String,
      default: '/setsail/v1/upload/image'
    },
    uploadFileParam: { // 文件上传参数
      type: String,
      default: 'uploadFile'
    },
    uploadOtherParams: { // 上传参数
      type: Array,
      default: function () {
        return []; // 格式：[{ key: '', value: '' }, { key: '', value: '' }]
      }
    },
    isMultiple: { // 是否允许一次选择多张图片上传 默认：不可以
      type: Boolean,
      default: false
    },
    upLoadMaxNumber: { // 上传的最大张数
      type: Number,
      default: 10
    },
    keyVal: String, // 是否进行前端解密
    edit: { // 是否可编辑 默认为true；false时，只能进行图片预览
      type: Boolean,
      default: true
    },
    ifCompress: { // 是否对图片进行压缩处理
      type: Boolean,
      default: false
    },
    imgMaxSize: { // 默认的上传的图片最大为10M  大于10M将不允许上传
      type: Number,
      default: 10
    }
  },
  mounted () {
    this.init();
  },
  // 监听images的变化
  watch: {
    images: function () {
      this.init();
    }
  },
  methods: {
    // 初始化方法
    init () {
      // test the createObjectURL
      if (!(window.URL.createObjectURL || window.webkitURL.createObjectURL)) {
        alert('This browser does not have URL.createObjectURL method.');
        return false;
      }
      this.imgList = []; // 先清空
      this.images.forEach((item) => {
        if (!item.status) {
          this.imgList.push({ url: item.url, status: 3, imageUrl: item.url }); // 图片状态: 3: 回显，2：新增，1：正在上传，0：已删除
        }
      });
    },
    // file 上传控件事件监听
    fileChange (event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!this.checkUploadImageNum(files)) return false;
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.size > this.imgMaxSize * 1024 * 1024) {
            alert(`${this.$t('ImageUpload.maxSize')}${this.imgMaxSize}M`);
            return false;
          }
          this.canvasCompress(file).then((params) => {
            this.uploadImg(params).then(([imgItem, url]) => {
              imgItem.status = 2; // 上传完成修改状态
              imgItem['imageUrl'] = url; // 追加七牛地址
              this.$refs.inputFile.value = ''; // 解决chrome input file 重复上传同一张图片失效的问题
              this.$emit('onChange', [].concat(this.imgList)); // 通过onChange事件返回给页面

              event.target.value = ''; // 置空，防止删除图片后无法再次选择
            });
          }, () => {
            console.log(`${this.$t('ImageUpload.compressionFailed')}`);
          });
        }
      }
    },
    // 给子组件使用的
    delImg (imageUrl) {
      const deleteIndexList = [];
      this.imgList.forEach((image, index) => {
        if (image.imageUrl == imageUrl) {
          if (image.status == 3) image.status = 0; // 如果是系统存在的图片则修改状态
          else deleteIndexList.push(index); // 如果是新增加的图片则删除即可
        }
      });
      deleteIndexList.forEach((deleteIndex) => {
        this.imgList.splice(deleteIndex, 1);
      });
      this.$emit('onChange', [].concat(this.imgList)); // 通过onChange事件返回给页面
    },
    // canvas压缩
    canvasCompress (file) {
      return new Promise((resolve, reject) => {
        if (!file) return false;
        const { name } = file;
        const img = new Image();
        const URL = window.URL || window.webkitURL; // 实现本地预览 类似url
        img.src = URL.createObjectURL(file);
        if (file.size <= 4 * 1024 * 1024 || !this.ifCompress) { // 小于4M或者不需要压缩时
          img.onload = () => {
            resolve({ file });
          };
          img.error = () => {
            reject(new Error('image load error'));
          };
        } else { // 大于4M 且需要压缩时
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          img.onload = () => {
            const { width, height, oldWidth, oldHeight } = this.getImgSize(img);
            let ratio = this.getPixelRatio();
            ratio = (ratio == 1 ? 2 : ratio);
            const ratioWidth = (width * ratio) > oldWidth ? oldWidth : (width * ratio);
            const ratioHeight = (height * ratio) > oldHeight ? oldHeight : (height * ratio);
            canvas.style.width = width;
            canvas.style.height = height;
            canvas.width = ratioWidth;
            canvas.height = ratioHeight;
            ctx.scale(ratioWidth / width, ratioHeight / height);
            ctx.drawImage(img, 0, 0, oldWidth, oldHeight, 0, 0, width, height);
            let tt = canvas.toDataURL('image/jpeg', 0.5);
            tt = tt.split(',')[1];
            const blob = this.b64ToBlob(tt, 'image/jpeg');
            blob.name = name;
            resolve({ file: blob });
          };
          img.error = () => {
            reject(new Error(`图片${name}压缩失败`));
          };
        }
      });
    },
    // 获取图片宽高尺寸
    getImgSize (img) {
      const oldWidth = img.naturalWidth || img.width;
      const oldHeight = img.naturalHeight || img.height;
      let width = oldWidth;
      let height = oldHeight;
      const rate = width / height;
      if (width > 1000) {
        width = 1000;
        height = parseInt(width / rate);
      }
      if (height > 1000) {
        height = 1000;
        width = parseInt(height * rate);
      }
      return { width, height, rate, oldWidth, oldHeight };
    },
    // 获取设备的像素比
    getPixelRatio () {
      return (window.devicePixelRatio || 1);
    },
    // base64转换Blob对象
    b64ToBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    // 上传图片
    uploadImg (params) {
      return new Promise((resolve, reject) => {
        const URL = window.URL || window.webkitURL;
        const url = URL.createObjectURL(params.file);
        const imgItem = { id: 0, url, status: 1 };
        this.imgList.push(imgItem); // 图片状态上传中 显示loading效果
        // ajax 上传图片
        this.$ajax.post(this.uploadUrl, this.getFormData(params.file), { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
          if (res.data.code == 200) {
            resolve([imgItem, res.data.data]);
          } else {
            this.imgList.splice(this.imgList.length - 1, 1);
            this.$refs.inputFile.value = ''; // 清空文件选取控件的值，防止失败之后再次选择不上的
            alert(res.data.msg);
          }
        }).catch((error) => {
          console.log(error);
          this.imgList.splice(this.imgList.length - 1, 1);
          this.$refs.inputFile.value = ''; // 清空文件选取控件的值，防止失败之后再次选择不上的
          alert(`${this.$t('ImageUpload.uploadFailed')}`);
        });
      });
    },
    getFormData (img) {
      const formData = new FormData(); // 初始化multipart/form-data 参数
      formData.append(this.uploadFileParam, img);
      if (this.uploadOtherParams && this.uploadOtherParams.length > 0) {
        this.uploadOtherParams.forEach((param) => {
          formData.append(param.key, param.value);
        });
      }
      return formData;
    },
    checkUploadImageNum (files) { // 检查已上传的图片的数量\
      let imageCount = 0;
      let result = true;
      for (let i = 0; i < this.imgList.length; i++) {
        if (this.imgList.status != 0) { // 筛选掉已删除图片
          imageCount++;
        }
      }
      imageCount += files ? files.length : 0; // 已上传的图片数量 + 本次上传的图片数量
      if (imageCount > this.upLoadMaxNumber) {
        alert(`${this.$t('ImageUpload.maxNumber')}${this.upLoadMaxNumber}`);
        result = false;
      }
      return result;
    },
    /**
     * 清空图片
     */
    clearImageList () {
      this.imgList = []; // 清空图片列表
      this.$emit('onChange', [].concat(this.imgList)); // 通过onChange事件返回给页面
    }
  },
  components: {
    ImgPreview
  }
};
</script>
<style scoped>
  .uploadWrap{
    background: url('../../assets/images/imgupload/upimg.png') scroll center center;
    width: 83px;
    height: 83px;
    background-size: 100%;
    border: 1px solid #ddd;
    position: relative;
    float: left;
    margin-right: 5px;
    margin-bottom: 5px;
    overflow: hidden;
    cursor: pointer;
  }
  .uploadWrap .inputFile{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0.01;
    cursor: pointer;
    z-index: 1;
  }
  .clearfix {
    zoom: 1;
  }
  .clearfix:after {
    clear: both;
    display: block;
    content: ".";
    height: 0;
    visibility: hidden;
  }
  .imgLoading {
    display: none;
  }
  .imgLoading.active{
    display: block;
  }
</style>
